module.exports = "/assets/8c4c43b95d020b5d9c81e72c42bdfae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TS.png
// module id = 2987
// module chunks = 0